import { render, staticRenderFns } from "./image-upload.vue?vue&type=template&id=6c47c8e4"
import script from "./image-upload.vue?vue&type=script&lang=js"
export * from "./image-upload.vue?vue&type=script&lang=js"
import style0 from "./image-upload.vue?vue&type=style&index=0&id=6c47c8e4&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c47c8e4')) {
      api.createRecord('6c47c8e4', component.options)
    } else {
      api.reload('6c47c8e4', component.options)
    }
    module.hot.accept("./image-upload.vue?vue&type=template&id=6c47c8e4", function () {
      api.rerender('6c47c8e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/image-upload.vue"
export default component.exports